import { LoginResponseDto } from "@/data/dto/login-response-dto";
import { LoginRequestPayload } from "@/data/payload/login-request-payload";
import { URLList } from "@/data/url_list";
import { createLogger, withApiLogging } from "@/utils/logger/logger";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";

export class LoginSource {
  private readonly logger = createLogger("LoginSource");

  constructor(private readonly client: FetchApiClientMethod) {}

  async login(payload: LoginRequestPayload): Promise<SATResult<LoginResponseDto, SATError>> {
    const url = URLList.USER.LOGIN;
    try {
      const data = await withApiLogging(this.logger, { method: "POST", url, payload }, async () => {
        const response = await this.client.post(url, payload);
        return response.data as LoginResponseDto;
      });
      return SATResult.success(data);
    } catch (error: unknown) {
      return SATResult.failure(errorConverter.convertError(error));
    }
  }

  async logout(): Promise<SATResult<void, SATError>> {
    const url = URLList.USER.LOGOUT;
    try {
      await withApiLogging(this.logger, { method: "POST", url }, async () => {
        const response = await this.client.post(url);
        return response.data;
      });
      return SATResult.success(void 0);
    } catch (error: unknown) {
      return SATResult.failure(errorConverter.convertError(error));
    }
  }
}
